(function() {


    const popUpCallmeTopBlock = document.querySelector('.popup-callme-top-block');    
    if ( !popUpCallmeTopBlock ) {
        return;
    }
    
    const popUpCallmeTopBlockForm = popUpCallmeTopBlock.querySelector('.popup-callme-content-wrapper');    
    if ( !popUpCallmeTopBlock || !popUpCallmeTopBlockForm ) {
        return;
    }


    const actionClose = popUpCallmeTopBlock.querySelector('.popup-callme-title-action-close');
    actionClose.addEventListener('click', () => {
        popUpCallmeTopBlockForm.classList.add('hidden');
        return false;
    });


    
    popUpCallmeTopBlock.querySelector('#popup-callme-top').addEventListener('click', () => {
        popUpCallmeTopBlockForm.classList.remove('hidden');
        return false;
    });


})();